<template lang="pug">
div
  //- #leaderboard-modal.modal.fade(tabindex='-1' aria-hidden='true')
    .modal-dialog.modal-dialog-centered
      .modal-content
        .position-absolute.close-button.pointer(@click="$helpers.closeModal('#leaderboard-modal')")
          i.fa-solid.fa-x.fa-2x
        .modal-body
          iframe#testIframe(style="width:100%; min-height: 600px;")
        .modal-footer.s2
          .text-center
            button.btn-submit(type='button' @click="$helpers.closeModal('#leaderboard-modal')") {{ $t('ui.close') }}
  .access(v-if="!showMobile" :class="{'loggedin': isLoggedIn}")
    .button-area.respon-width(:class="{'width-auto': isLoggedIn || getLanguage==='ph'}")
      template(v-if="!isLoggedIn")
        template(v-if="!showMobile")
          a.btn-login(href='javascript:void(0)' @click="openLogModal()") {{$t('ui.login')}}
          a.btn-register(href='javascript:void(0)' @click="openRegisterModal()") {{$t('ui.register')}}
      template(v-else)
        .profile
          i.fa-solid.fa-circle-user(v-if="getAvatar===''")
          img(v-else :src="getAvatar")
        .text-left.user-info.pointer(@click="$helpers.redirect('deposit')")
          span.username.float-start {{accountID}}
          br
          span.balance.float-start PHP {{ $numeral($store.getters.balance).format("0,0.00") }}
            //- i.fa-solid.fa-eye
      .lvl-img.pointer.ms-1(v-if="getVip!==''")
        img.lvl-img.custom-hide.pointer(v-if="getVip!==''" :src="'assets/img/vip/'+getVip+'.png'" @click="$helpers.redirect('vip')")
      //- .d-flex.justify-content-center.align-items-center
        .u-lvl.text-white.ms-2 Rookie
      .dropdown.lang
        button#lang.btn.dropdown-toggle(type='button' data-bs-toggle='dropdown' aria-expanded='false')
          a(href='javascript:void(0)')
            img(:src="'assets/img/lang-'+getLanguage+'.png'")
        ul.dropdown-menu(aria-labelledby='lang')
          li
            a(href='javascript:void(0)' @click="setLanguage('ph')")
              img(src='assets/img/lang-ph.png')
          li
            a(href='javascript:void(0)' @click="setLanguage('en')")
              img(src='assets/img/lang-en.png')
  //- .access.mobile-scroll(v-if="showMobile && isLoggedIn")
    .button-area
      template(v-if="!isLoggedIn")
        //- a.btn-login(href='javascript:void(0)' @click="openLogModal()") {{$t('ui.login')}}
        //- a.btn-register(href='javascript:void(0)' @click="openRegisterModal()") {{$t('ui.register')}}
      template(v-else)
        router-link.btn-register(to='deposit') {{$t('ui.deposit')}} 
          i.fa-solid.fa-coins
        router-link.btn-login(to="withdrawal") {{$t('ui.withdrawal')}}  
          i.fa-solid.fa-circle-dollar-to-slot
  .ann
    .icon.pointer(@click="$helpers.openModal('#annModal')")
      img(src='assets/img/ann-icon.png')
    .text
      marquee#mqAnnouncement(onmouseover='this.stop();' onmouseout='this.start();' scrollamount='5') {{$t('ui.notice_welcome')}}
  .banner
    //- .slider.banner-image
      .main-banner(v-for="(slide, index) in slideBannerList" )
        a.pointer(v-if="getLanguage ==='en'" href="javascript:void(0)"  @click="clickAction(slide.login_required, slide.target_window, slide.en_href)")
          img.w-100(:src='imgUrl+slide.en_image_url_desktop' :alt="slide.en_alt")
        a.pointer(v-else href="javascript:void(0)"  @click="clickAction(slide.login_required, slide.target_window, slide.fil_href)")
          img.w-100(:src='imgUrl+slide.fil_image_url_desktop' :alt="slide.fil_alt")

    #carouselBanner.carousel.slide(data-bs-ride='carousel')
      .carousel-indicators
        template(v-for="(slide, index) in slideBannerList" )
          button(v-if="index === 0" :class="{'active' : index === 0}" data-bs-target='#carouselBanner' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
          button(v-else data-bs-target='#carouselBanner' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
      .carousel-inner
        .carousel-item(:class="{'active' : index === 0}" v-for="(slide, index) in slideBannerList")
          img.d-block.w-100(v-if="getLanguage ==='en'" :src='imgUrl+slide.en_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.en_href)")
          img.d-block.w-100(v-else :src='imgUrl+slide.fil_image_url_desktop' @click="clickAction(slide.login_required, slide.target_window, slide.en_href)")
  .banner-m
    #carouselBannerM.carousel.slide(data-bs-ride='carousel')
      .carousel-indicators.custom-indicators
        template(v-for="(slide, index) in slideBannerList" )
          button(v-if="index === 0" :class="{'active' : index === 0}" data-bs-target='#carouselBannerM' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
          button(v-else data-bs-target='#carouselBannerM' :data-bs-slide-to='index' aria-current='true' :aria-label="'Slide '+index+1")
      .carousel-inner
        .carousel-item(:class="{'active' : index === 0}" v-for="(slide, index) in slideBannerList")
          img.d-block.w-100(v-if="getLanguage ==='en'" :src='imgUrl+slide.en_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.en_href)")
          img.d-block.w-100(v-else :src='imgUrl+slide.fil_image_url_mobile' @click="clickAction(slide.login_required, slide.target_window, slide.en_href)")
  //- .dbar-wrapper.mt-2.mt-md-0
    .dbar.text-center
      //- img.pointer(:src="'assets/img/always.png'" @click="gamification")
      //- img.pointer(:src="'assets/img/tournament-'+getLanguage+'.png'" @click="eventAction")
      img.pointer(:src="'assets/img/tournament.png'" @click="eventAction")
      //- router-link.pointer(to="ambassador")
        img(src="assets/img/ambassador.png")
      //- .iimg
      //-   img(src='assets/img/dbar/roof.png')
      //- .ccon
        .ffloat
          img(src='assets/img/dbar/angpao.gif')
        .ttitle
          img(src='assets/img/dbar/title.png')
        .ddate
          img.pointer(src='assets/img/dbar/more-btn.png' @click="eventAction")
  //- iframe#testIframe(style="width:100%")
  //- .chk-in-wrapper
    .ttitle
      img(src='assets/img/checkin/title.png')
    //- .ddesc 5 days, 5 missions, 5 bonuses
    .chk-in
      div
        .cibox.pointer(@click="eventAction").ready
          .rimg
            img(src='assets/img/checkin/1.png')
          .rday 
            img(src='assets/img/checkin/27_7.png')
      div
        .cibox.pointer(@click="eventAction")
          .rimg
            img(src='assets/img/checkin/2.png')
          .rday 
            img(src='assets/img/checkin/28_7.png')
      div
        .cibox.pointer(@click="eventAction")
          .rimg
            img(src='assets/img/checkin/3.png')
          .rday 
            img(src='assets/img/checkin/29_7.png')
      div
        .cibox.pointer(@click="eventAction")
          .rimg
            img(src='assets/img/checkin/4.png')
          .rday 
            img(src='assets/img/checkin/30_7.png')
      div
        .cibox.pointer(@click="eventAction")
          .rimg
            img(src='assets/img/checkin/5.png')
          .rday 
            img(src='assets/img/checkin/31_7.png')
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/6.png')
      //-     .rday 6
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/7.png')
      //-     .rday 7
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m8.png')
      //-     .rday 8
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m9.png')
      //-     .rday 9
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m10.png')
      //-     .rday 10
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m11.png')
      //-     .rday 11
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m12.png')
      //-     .rday 12
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m13.png')
      //-     .rday 13
      //- div
      //-   .cibox.pointer(@click="eventAction")
      //-     .rimg
      //-       img(src='assets/img/checkin/m14.png')
      //-     .rday 14
      //- div
        .cibox.pointer(@click="eventAction")
          .rimg
            img(src='assets/img/checkin/m15.png')
          .rday 15
  .realtime-trans.pointer(@click="showReview")
    .tt {{ $t("ui.real_time") }}
      br
      | {{ $t("ui.transaction") }}
    .ccon
      .rtt-wrap
        .vv-rtt
          template(v-if="topTenList")
            div(v-for="x in topTenList")
              .rttbox
                .rimg
                  img(src='assets/img/user.png')
                .rcon
                  div
                    span {{ x.member_id }}
                    span.time {{$moment(x.action_date).locale(getLanguageDisplay).fromNow()}}
                  div
                    span {{ $tc('ui.topten_'+x.transfer_type) }}
                    span.amo PHP {{ x.transfer_amount.toFixed(2) }}
</template>
<script>
import config from "@/config";
export default {
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      imgUrl: config.imageUrl,
      slideBannerList:[],
      showMobile: false,
      topTenList: [],
    };
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getLanguageDisplay(){
      return this.$tc(`ui.language.${this.$store.getters.language}`) || this.$tc('ui.language.en')
    },
    getAvatar(){
      return this.$store.getters.getAvatar
    },
    getCurrentLevel(){
      return this.$store.getters.getCurrentLevel
    },
    getAnnBeforeLog(){
      return this.$store.state.user.annBeforeLog
    },
    getAnnAfterLog(){
      return this.$store.state.user.annAfterLog
    },
    getVip(){
      return this.$store.state.user.vip
    }
  },
  created(){
    this.getSlideBanner()
  },
  beforeUpdate(){
    $('.banner .slider').filter('.slick-initialized').slick('unslick');
    $('.vv-rtt').filter('.slick-initialized').slick('unslick');
    // $('.banner-m .slider').filter('.slick-initialized').slick('unslick');
  },
  updated(){
    $(".banner .slider").slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 15000,
      infinite: true
    });
    $('.vv-rtt').not('.slick-initialized').slick({
      dots: false,
      infinite: true,
      arrows: false,
      speed: 300,
      autoplaySpeed: 2000,
      slidesToShow: 6,
      slidesToScroll: 1,
      pauseOnFocus: false,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
    // $(".banner-m .slider").slick({
    //   arrows: false,
    //   dots: true,
    //   autoplay: true,
    //   autoplaySpeed: 15000,
    //   infinite: true
    // });
  },
  beforeMount(){
    this.checkSize()
  },
  mounted(){
    var vm = this
    $(window).resize(function () {
      vm.checkSize()
    });
    $(".banner .slider").slick({
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 15000,
      infinite: true
    });

    $('.chk-in').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      autoplaySpeed: 2000,
      slidesToShow: 5,
      slidesToScroll: 1,
      pauseOnFocus: false,
      autoplay: false
    });
    this.getTopTenDepWit()
    // $(".banner-m .slider").slick({
    //   arrows: false,
    //   dots: true,
    //   autoplay: true,
    //   autoplaySpeed: 15000,
    //   infinite: true
    // });
    $("#leaderboard-modal").on("shown.bs.modal", function() {
      window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 209} )
    });
  },
  
  methods:{
    eventAction(){
      if(this.isLoggedIn){
        // $("#leaderboard-modal").modal("show")
        // window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 2} )
        // _smartico.dp("dp:gf_section&id=203") //missions
        _smartico.dp("dp:gf_tournaments&id=1271")
        // _smartico.dp("dp:gf_section&id=282")
        // _smartico.dp("dp:gf_section&id=292")

      }else{
        this.openLogModal()
      }
    },
    showReview(){
      this.$router.push("/review").catch(error =>{})
    },
    getTopTenDepWit(){  //get top ten deposit withdrawal
      let url = config.getTopTenDepositWithdraw();
      // var json = {
      //   app_id : config.app_id
      // }
      this.$http.get(url).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;
              if (this.feedback.success == true) {
                this.topTenList = response.data.value
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
          }
        }
      );
      
    },
    checkSize(){
      if ($(window).width() < 681) {
        this.showMobile = true
      }else{
        this.showMobile = false
      }
    },
    openLogModal(){
      $("#logModal").modal("show")
    },
    openRegisterModal(){
      $("#regModal").modal("show")
    },
    getSlideBanner(){
      this.$store
        .dispatch("user/getSlideBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.slideBannerList = response.data
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
    clickAction(checkLogin, target, link){
      if(checkLogin){
        if(!this.isLoggedIn){
          $('#logModal').modal('show')
        }else{
          if(target === "_blank"){
            setTimeout(() => {
              window.open(link, target)
            }) 
          }else{
            if(link=="smartico"){
              this.gamification()
            }else{
              this.$router.push("/"+link).catch(error =>{})
            }
          }
        }
      }
    },
    gamification(){
      // console.log('here', window._smartico)
      // window._smartico.dp('dp:gf');
      // _smartico.dp('dp:gf')
      if(this.isLoggedIn){
        _smartico.dp('dp:gf')
      }else{
        $('#logModal').modal('show')
      }
    },
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload)
    },
  }
}
</script>
<style lang="scss" scoped>
.show-display{
  @media(min-width: 681px) {
    display: none;
  }
}
#lang{
  a{
    line-height: 20px;
  }
  
}
ul{
  li{
    a{
      line-height: 20px !important;
    }
  }
}
.width-auto{
  width: auto !important;
  // @media(min-width: 681px){
  //   width: auto !important;
  // }
}
.mobile-scroll{
  position: fixed;
  z-index: 2;
  width: 100%;
}

//leaderboard modal
.modal-dialog{
  max-width: 1000px;
}
</style>